import { render, staticRenderFns } from "./ShipPanel.vue?vue&type=template&id=7df24cd3&"
import script from "./ShipPanel.vue?vue&type=script&lang=ts&"
export * from "./ShipPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports